import { RoutalPalette } from '@nx-smartmonkey/ui';
import styled from 'styled-components';

import { STOP_STATUS } from '../../../constants/Stops';
import { Driver } from '../../../domain/driver/Driver';
import { StopStatus } from '../../../domain/stop/StopStatus';

const DriverRouteProgressContainer = styled.div<{ hasStops: boolean }>`
  height: 10px;
  width: 100%;
  display: flex;
  flex-direction: row;
  margin-top: 12px;
  border-radius: 15px;
  background-color: ${(props: any) => (!props.hasStops ? `#EBEBEB` : ``)};
`;

const DriverRouteProgressItem = styled.div<{ status?: StopStatus }>`
  flex: 1;
  margin-right: 1px;
  :first-child {
    border-top-left-radius: 15px;
    border-bottom-left-radius: 15px;
  }
  :last-child {
    margin-right: unset;
    border-top-right-radius: 15px;
    border-bottom-right-radius: 15px;
  }
  background-color: ${(props: any) => {
    switch (props.status) {
      case STOP_STATUS.completed:
        return RoutalPalette.statusColors.completed;
      case STOP_STATUS.incomplete:
        return RoutalPalette.statusColors.incomplete;
      case STOP_STATUS.canceled:
        return RoutalPalette.statusColors.canceled;
      default:
        return RoutalPalette.statusColors.pending;
    }
  }};
`;

export const DriverRouteProgress = ({ driver }: { driver: Driver }) => (
  <DriverRouteProgressContainer id={`driver-${driver.id}-progress`} hasStops={Boolean(driver.stops.length > 0)}>
    {driver.stops.map((stop) => (
      <DriverRouteProgressItem
        key={`driver-${driver.id}-progress-${stop.id}`}
        id={`driver-${driver.id}-progress-${stop.id}`}
        status={stop.status}
      />
    ))}
  </DriverRouteProgressContainer>
);
